module.exports = __webpack_public_path__ + "img/ring_g_l_null_0@3x.897252fc.png";